module.exports = __webpack_public_path__ + "static/media/logo.78080f31.png";